export const DATE = 'DATE';
export const DATETIME = 'DATETIME';
export const NUMERIC = 'NUMERIC';
export const LONG = 'LONG';
export const DOUBLE = 'DOUBLE';
export const STRING = 'STRING';
